<template>
	<div class="stock">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0 text-gray mt-3 mt-md-0">
					<ml-menu></ml-menu>
					<div class="col-12 p-0 pb-3">
						<div class="container p-0 p-md-2">
							<div class="row">
								<div class="col-6 col-md-6 mt-5 mt-md-5">
									<div class="col-md-12 d-md-flex pl-0 mt-2">
										<h4>Stok</h4>
									</div>
								</div>
								<div class="col-6 pr-0 col-md-6 mt-5 mt-md-5 d-none d-sm-block">
									<nav aria-label="breadcrumb">
										<ol class="breadcrumb float-right">
											<li class="breadcrumb-item"><a href="javascript:;">Dashboard</a></li>
											<li class="breadcrumb-item active" aria-current="page"><a href="javascript:;">Stok</a></li>
										</ol>
									</nav>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-lg-12 col-md-12">
									<div class="col-12 p-0">
										<div class="row" v-show="stock.length == 0 ">
											<div class="col-12 col-md-6 col-lg-3 d-flex pb-3 pl-3 pr-3" v-for=" index in 3" :key="index">
												<div class="col-12 p-0 pt-2 pb-2 background-white rounded cus-box-shadow">
													<vcl :width='400' :height='130'>
														<rect x="310" y="32" rx="10" ry="10" width="60" height="60" />
														<rect x="25" y="30" rx="2" ry="2" width="250" height="25" />
														<rect x="25" y="70" rx="2" ry="2" width="170" height="25" />
													</vcl>
												</div>
											</div>
										</div>
										<div v-if="stock.length > 0 ">
											<carousel ref="carousel" id="owl-menu" class="" :responsive="{0:{items:1},600:{items:2},1000:{items:3}}" :margin="10" :autoplay="false" :nav="false" :loop="false" :dots="true">
											<div v-for=" (value, index) in stock" :key="index">
												<div class="col-12 p-0 background-white rounded cus-box-shadow">
													<div class="d-flex flex-wrap">
														<div class="col-9 col-md-10 pr-0 pt-3 pb-3 pl-3 font-size-11">
															<p class="mb-n1">{{value.product_name}}</p>
															<h3 class="text-purple mb-0">{{ value.stock_store |toNumber }}</h3>
														</div>
														<div class="col-3 col-md-2 pl-md-0 mt-auto mb-auto">
															<img class="img-fluid" src="assets/icon/icon-stok-produk.png">
														</div>
													</div>
												</div>
											</div>
										</carousel>
										</div>
									</div>
								</div>
							</div>
							<div class="row mt-3" id="tab-stok">
								<div class="col-12 mb-2">
									<div class="col-12 p-0">
										<div class="row">
											<div class="col-12">
												<div class="background-white rounded cus-box-shadow overflow-auto">
													<ul class="nav nav-pills font-size-11 font-size-sm-10 stock-product-slider" id="pills-tab" v-if="stock.length > 0">
														<li class="nav-item border-right border-gray-2">
															<a class="nav-link text-gray" :class=" tab == 'riwayat' ? 'active' : '' " role="tab" aria-controls="riwayat-stok-produk" @click="riwayatSerial" aria-selected="true" href="javascript:;"><p class="m-0">Riwayat Stok Produk</p></a>
														</li>
														<li class="nav-item border-right border-gray-2" v-for="value in summarySerial" :key="value.stock_serial_type">
															<a class="nav-link text-gray" :class=" tab == 'serial' && produk == value.stock_serial_name ? 'active' : '' " @click="tipeSerial(value.stock_serial_type, value.stock_serial_name)" href="javascript:;"><p class="m-0">{{value.stock_serial_name}}</p></a>
														</li>
													</ul>
													<ul class="nav nav-pills font-size-11 font-size-sm-8" id="pills-tab" v-else>
														<li class="col nav-item text-center p-0" v-for="a in 3" :key="a">
															<vcl :width='100' :height='10'>
																<rect x="10" y="2" rx="1" ry="1" width="80" height="6" />
															</vcl>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-if="tab == 'riwayat'">
								<div>
									<div class="row">
										<div class="col-12 col-md-12 mb-2 mt-2">
											<div class="col-12 p-0 background-white rounded-top cus-box-shadow z-index-1">
												<div class="col-12 p-0 d-flex pt-3 pl-4">
													<div class="col-12 p-0">
														<div class="row">
															<div class="col-6 col-md-6 font-size-sm-11">
																<p>Riwayat Stok Produk</p>
															</div>
															<!-- <div class="col-6 col-md-6 mt-n1 pr-4">
																<button class="btn btn-mila text-white font-size-10 float-right box-purple" data-toggle="modal" data-target="#modalChangeProfile"><img src="assets/icon/excel.png" class="img-fluid pr-2">Export Data</button>
															</div> -->
														</div>
													</div>
												</div>
											</div>
											<div class="col-12 p-0 background-gray-light rounded-bottom cus-box-shadow">
												<a class="text-gray" data-toggle="collapse" href="#collapseFilterStokSerial" role="button" aria-expanded="false" aria-controls="collapseExample">
													<div class="col-12 p-0 d-flex pt-3 pl-4 pb-2">
														<div class="col-12 p-0">
															<div class="row font-size-sm-10 font-size-12">
																<div class="col-12 col-md-12 mt-n1">
																	<img src="assets/icon/filter.png" class="pr-1">Filter
																</div>
															</div>
														</div>
													</div>
												</a>
												<div class="col-12 col-md-12 mt-1 font-size-sm-10 font-size-11 collapse" id="collapseFilterStokSerial">
													<div class="row pb-3">
														<div class="col-12 col-lg-5 col-md-8">
															<div class="row">
																<div class="col-4 col-lg-4 col-md-3 mt-1 pl-4">
																	<span>Tanggal</span>
																</div>
																<div class="col-4 col-lg-4 col-md-4 pl-0 pr-2">
																	<datepicker input-class="form-control font-size-sm-8 font-size-9 form-control-sm text-gray box-purple fullscreen-when-on-mobile" v-model="tanggalAwal" placeholder="Dari Tanggal" :language="indonesia" bootstrap-styling>
																	</datepicker>
																</div>
																<div class="col-4 col-lg-4 col-md-4 pl-0 pr-2">
																	<datepicker input-class="form-control font-size-sm-8 font-size-9 form-control-sm text-gray box-purple fullscreen-when-on-mobile" v-model="tanggalAkhir" placeholder="Sampai Tanggal" :language="indonesia" bootstrap-styling>
																	</datepicker>
																</div>
															</div>
														</div>
													</div>
													<div class="row pb-3">
														<div class="col-12 col-lg-5 col-md-8 pt-2 pt-md-0">
															<div class="row">
																<div class="col-4 col-lg-4 col-md-3 mt-1 pl-4">
																	<span>Produk</span>
																</div>
																<div class="col-8 pl-0 pr-2">
																	<select v-model="filter.filter[1].value" class="form-control font-size-sm-8 font-size-9 form-control-sm text-gray box-purple" placeholder="Dari Tanggal">
																		<option value="">Pilih Produk</option>
																		<option v-for="(value, index) in stock" :key="index" :value="value.product_id">{{value.product_name}}</option>
																	</select>
																</div>
															</div>
														</div>
														<div class="col-8 offset-4 col-lg-4 col-md-10 offset-md-2 offset-lg-0 pt-2 pl-md-0 pl-lg-3 pt-md-3 pt-lg-0 pl-0 pr-0 pr-md-3">
															<div class="row">
																<div class="col-md-12 float-right pr-md-2">
																	<button class="btn btn-mila btn-cari text-white font-size-10 font-size-sm-8 pt-1 pb-1 pl-md-5 pr-md-5 pl-lg-5 pr-lg-5 box-purple" @click="resetRiwayat()">Reset</button>
																	<button class="btn btn-mila btn-cari text-white font-size-10 font-size-sm-8 pt-1 pb-1 pl-md-5 pr-md-5 pl-lg-5 pr-lg-5 ml-md-4 ml-2 box-purple" @click="cariRiwayat()">Cari</button>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="row" v-show="riwayatStockResults.length == 0 ">
										<div class="col-12 pb-2" v-for=" (index) in 3" :key="index">
											<div class="col-12 pt-3 pb-3 background-white rounded cus-box-shadow font-size-10 font-size-sm-9">
												<vcl :width='400' :height='10'>
													<rect x="5" y="3" rx="1" ry="1" width="7" height="7" />
													<rect x="15" y="3" rx="1" ry="1" width="70" height="7" />
												</vcl>
												<div class="col-12 pt-2 pb-2">
													<div class="row">
														<div class="col-12 col-lg-6 pl-2 pr-2 pt-1 pb-1" v-for=" (idx) in 2" :key="idx">
															<vcl :width='300' :height='50' class="background-white rounded cus-box-shadow ">
																<rect x="10" y="13" rx="3" ry="3" width="25" height="25" />
																<rect x="45" y="13" rx="2" ry="2" width="80" height="10" />
																<rect x="145" y="13" rx="2" ry="2" width="50" height="10" />
																<rect x="230" y="16" rx="2" ry="2" width="50" height="17" />
																<rect x="45" y="28" rx="2" ry="2" width="80" height="10" />
																<rect x="145" y="28" rx="2" ry="2" width="50" height="10" />
															</vcl>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<!-- data kosong -->
									<div class="row" v-if="riwayatStockResults == 'error'">
										<div class="col-12 col-md-12 p-0 d-flex pb-2 pl-3 pr-3">
											<div class="col-12 p-0 pb-2 background-white rounded cus-box-shadow">
												<div class="col-12 p-0 d-flex pb-2 pl-4">
													<div class="col-12 p-0">
														<div class="row">
															<div class="col-md-12 col-12 mt-1 text-center">
																<img src="assets/icon/stock_empty.svg" width="100px;" class="mt-n3">
																<p class="mb-n1 font-size-sm-11 font-size-12">Data Tidak Tersedia</p>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="row" v-else>
										<div class="col-12 pb-2" v-for=" (value, index) in riwayatStockResults" :key="index">
											<div class="col-12 pt-3 pb-3 background-white rounded cus-box-shadow font-size-10 font-size-sm-9">
												<div class="col-12 pl-2"><span><img src="assets/icon/kalendar_color.png" class="img-fluid pl-1 pr-1 mt-n1"></span>{{value.date | toTanggal}}</div>
												<div class="col-12 pt-2 pb-2">
													<div class="row">
														<div class="col-12 col-lg-6 pl-2 pr-2 pt-1 pb-1" v-for=" (val, idx) in value.product" :key="idx">
															<div class="col-12 pt-3 pb-3 pl-0 pr-0 background-white rounded cus-box-shadow d-md-flex">
																<div class="col-3 col-lg-2 col-md-1 d-none d-md-block mt-auto mb-auto">
																	<img :src="val.product_image_filename ? val.product_image_filename : 'assets/icon/icon-stok-produk.png'" class="img-fluid width-80-pct">
																</div>
																<div class="col-12 col-lg-4 col-md-4 pl-lg-0 pr-md-0 mt-auto mb-auto">
																	<div>{{val.product_name}}</div>
																	<div class="pt-1"><img src="assets/icon/serial_in.png" class="img-fluid mt-n1 pr-1"><span>{{val.stock_log_daily_in}}</span><img src="assets/icon/serial_out.png" class="img-fluid mt-n1 pl-2 pr-1"><span>{{val.stock_log_daily_out | toNumber}}</span></div>
																</div>
																<div class="col-12 col-md-7 col-lg-6 pl-0 pr-0 d-flex pt-3 pt-md-0 justify-content-between">
																	<div class="col-6 pr-0 mt-auto mb-auto">
																		<div>Stok Terakhir</div>
																		<div class="pt-1"><img src="assets/icon/stok_serial.png" class="img-fluid mt-n1 pr-1"><span>{{val.stock_log_daily_last_balance |toNumber}}</span></div>
																	</div>
																	<div class="col-6 mt-auto mb-auto">
																		<div>
																			<button class="col-12 col-md-12 btn btn-mila text-white font-size-sm-10 box-purple" data-toggle="modal" data-target="#modalDetailRiwayat" @click="getDetail(val)">DETAIL</button>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div id="cobacoba" v-else>
								<div>
									<div class="row">
										<div class="col-12 col-md-12 mb-2 mt-2">
											<div class="col-12 p-0 background-white rounded-top cus-box-shadow z-index-1">
												<div class="col-12 p-0 d-flex pt-3 pl-4">
													<div class="col-12 p-0">
														<div class="row">
															<div class="col-6 col-md-6 font-size-sm-11">
																<p class="">{{produk}}</p>
															</div>
															<!-- <div class="col-6 col-md-6 mt-n1 pr-4">
																<button class="btn btn-mila text-white font-size-10 float-right box-purple" data-toggle="modal" data-target="#modalChangeProfile"><img src="assets/icon/excel.png" class="img-fluid pr-2">Export Data</button>
															</div> -->
														</div>
													</div>
												</div>
											</div>
											<div class="col-12 p-0 background-gray-light rounded-bottom cus-box-shadow">
												<a class="text-gray" data-toggle="collapse" href="#collapseFilterStarterkit" role="button" aria-expanded="false" aria-controls="collapseExample">
													<div class="col-12 p-0 d-flex pt-3 pl-4 pb-2">
														<div class="col-12 p-0">
															<div class="row font-size-sm-10 font-size-12">
																<div class="col-12 col-md-12 mt-n1">
																	<img src="assets/icon/filter.png" class="pr-1">Filter
																</div>
															</div>
														</div>
													</div>
												</a>
												<div class="col-12 col-md-12 mt-1 font-size-sm-10 font-size-11 collapse" id="collapseFilterStarterkit">
													<div class="row">
														<div class="col-12 col-lg-4 pt-2 pt-md-0">
															<div class="row">
																<div class="col-4 col-md-3 col-lg-4 mt-1 pl-4">
																	<span>Pembelian</span>
																</div>
																<div class="col-4 col-md-3 col-lg-4 pl-0 pr-2">
																	<datepicker :language="indonesia" input-class="form-control font-size-9 font-size-sm-8 form-control-sm text-gray box-purple" v-model="tanggalAwalPembelian" placeholder="Dari Tanggal" bootstrap-styling>
																	</datepicker>
																</div>
																<div class="col-4 col-md-3 col-lg-4 pl-0 pr-2">
																	<datepicker :language="indonesia" input-class="form-control font-size-9 font-size-sm-8 form-control-sm text-gray box-purple" v-model="tanggalAkhirPembelian" placeholder="Sampai Tanggal" bootstrap-styling>
																	</datepicker>
																</div>
															</div>
														</div>
														<div class="col-12 col-lg-4 pt-md-0 mt-md-3 mt-lg-0">
															<div class="row">
																<div class="col-4 col-md-3 col-lg-4 mt-1 pl-4">
																	<span>Kadaluarsa</span>
																</div>
																<div class="col-4 col-md-3 col-lg-4 pl-0 pr-2">
																	<datepicker :language="indonesia" input-class="form-control font-size-9 font-size-sm-8 form-control-sm text-gray box-purple" v-model="tanggalAwalKadaluarsa" placeholder="Dari Tanggal" bootstrap-styling>
																	</datepicker>
																</div>
																<div class="col-4 col-md-3 col-lg-4 pl-0 pr-2">
																	<datepicker :language="indonesia" input-class="form-control font-size-9 font-size-sm-8 form-control-sm text-gray box-purple" v-model="tanggalAkhirKadaluarsa" placeholder="Sampai Tanggal" bootstrap-styling>
																	</datepicker>
																</div>
															</div>
														</div>
														<div class="col-12 col-lg-4 pt-md-0 mt-md-3 mt-lg-0">
															<div class="row">
																<div class="col-4 col-md-3 mt-1 pl-4">
																	<span>Terjual</span>
																</div>
																<div class="col-4 col-md-3 col-lg-4 pl-0 pr-2">
																	<datepicker :language="indonesia" input-class="form-control font-size-9 font-size-sm-8 form-control-sm text-gray box-purple" v-model="tanggalAwalTerjual" placeholder="Dari Tanggal" bootstrap-styling>
																	</datepicker>
																</div>
																<div class="col-4 col-md-3 col-lg-4 pl-0 pr-2">
																	<datepicker :language="indonesia" input-class="form-control font-size-9 font-size-sm-8 form-control-sm text-gray box-purple" v-model="tanggalAkhirTerjual" placeholder="Sampai Tanggal" bootstrap-styling>
																	</datepicker>
																</div>
															</div>
														</div>
													</div>
													<div class="row pb-3">
														<div class="col-12 col-lg-4 pt-md-3">
															<div class="row">
																<div class="col-4 col-md-3 col-lg-4 mt-1 pl-4">
																	<span>Serial</span>
																</div>
																<div class="col-8 col-md-3 col-lg-8 p-0 pr-2">
																	<input type="text" v-model="noSerial.value" class="form-control form-control-sm font-size-9 box-purple text-gray" placeholder="Kode Serial">
																</div>
															</div>
														</div>
														<div class="col-12 col-md-6 col-lg-4 pt-2 pt-md-3">
															<div class="row">
																<div class="col-4 col-md-6 col-lg-4 mt-1 pl-4">
																	<span>Status</span>
																</div>
																<div class="col-8 col-md-6 col-lg-8 p-0 pr-2">
																	<select class="form-control form-control-sm font-size-9 box-purple text-gray" v-model="pilihanSerial">
																		<option v-for="filter in pilihanStatusSerial" :key="filter.value" :value="filter.value">{{ filter.name }}</option>
																	</select>
																</div>
															</div>
														</div>
														<div class="col-8 offset-4 col-md-5 offset-md-0 col-lg-3 offset-lg-1 pt-2 pt-md-3 pr-md-3 pr-0 pl-2 pl-md-3">
															<div class="row">
																<div class="col-md-12 pl-4 pl-md-0 pl-lg-0">
																	<button class="btn btn-mila btn-reset-serial text-white font-size-10 font-size-sm-8 pt-1 pb-1 pl-4 pr-4 mr-n2 box-purple" @click="resetSerial()">Reset</button>
																	<button class="btn btn-mila btn-cari-serial text-white font-size-10 font-size-sm-8 pt-1 pb-1 pl-4 pr-4 mr-n2 box-purple ml-3" @click="cariSerial()">Cari</button>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="row" v-show="listStockResults.length == 0 ">
										<div class="col-12 col-lg-4 col-md-6" v-for=" (index) in 9" :key="index">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-12 col-md-12 pb-2 pl-3">
														<div class="col-12 p-0 mt-2 background-white rounded cus-box-shadow">
															<vcl :width='300' :height='140' class="background-white rounded cus-box-shadow ">
																<rect x="230" y="0" rx="20" ry="5" width="170" height="20" />
																<rect x="20" y="20" rx="2" ry="2" width="95" height="15" />
																<rect x="20" y="42" rx="2" ry="2" width="80" height="15" />
																<rect x="20" y="70" rx="2" ry="2" width="80" height="12" />
																<rect x="120" y="70" rx="2" ry="2" width="130" height="12" />
																<rect x="20" y="90" rx="2" ry="2" width="60" height="12" />
																<rect x="120" y="90" rx="2" ry="2" width="130" height="12" />
																<rect x="20" y="110" rx="2" ry="2" width="85" height="12" />
																<rect x="120" y="110" rx="2" ry="2" width="130" height="12" />
															</vcl>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="row" v-if="listStockResults.length > 0 ">
										<div class="col-12 col-lg-4 col-md-6" v-for=" (value, index) in listStockResults" :key="index">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-12 col-md-12 pb-2 pl-3">
														<div class="col-12 p-0 mt-2 background-white rounded cus-box-shadow" v-if="value.stock_serial_value"> 
															<div v-html="cekExpiredDates(value.stock_serial_status, value.stock_serial_expired_datetime)"></div>
															<div class="col-12 p-0 d-flex pb-2 pl-3">
																<div class="col-12 p-0 mt-n3">
																	<div class="row">
																		<div class="col-11 col-md-11">
																			<span class="font-size-10">{{value.stock_serial_type_text}}</span>
																			<p class="mb-n1 font-size-12 text-purple">{{ value.stock_serial_value }}</p>
																			<div class="row pt-4">
																				<div class="col-4 col-md-4 d-flex pr-0">
																					<span class="font-size-10">Pembelian</span>
																				</div>
																				<div class="col-8 col-md-8 d-flex pr-0">
																					<span class="font-size-10">{{ value.stock_serial_buy_datetime | tanggal}}</span>
																				</div>
																			</div>
																			<div class="row pt-2 pb-2">
																				<div class="col-4 col-md-4 d-flex pr-0">
																					<span class="font-size-10">Terjual</span>
																				</div>
																				<div class="col-8 col-md-8 d-flex pr-0" v-if="!value.stock_serial_sell_datetime">
																					<span class="font-size-10"> - </span>
																				</div>
																				<div class="col-8 col-md-8 d-flex pr-0" v-else>
																					<span class="font-size-10">{{value.stock_serial_sell_datetime | tanggal}}</span>
																				</div>
																			</div>
																			<div class="row pt-0 pb-3">
																				<div class="col-4 col-md-4 d-flex pr-0">
																					<span class="font-size-10 text-gray-light">Kadaluarsa</span>
																				</div>
																				<div class="col-8 col-md-8 d-flex pr-0">
																					<span class="font-size-10 text-gray-light">{{value.stock_serial_expired_datetime | tanggal}}</span>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- data kosong -->
							<div class="row" v-if="listStockResults == 'error'">
								<div class="col-12 col-md-12 p-0 d-flex pb-2 pl-3 pr-3">
									<div class="col-12 p-0 pb-2 background-white rounded cus-box-shadow">
										<div class="col-12 p-0 d-flex pb-2 pl-4">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-md-12 col-12 mt-1 text-center">
														<img src="assets/icon/stock_empty.svg" width="100px;" class="mt-n3">
														<p class="mb-n1 font-size-sm-11 font-size-12">Data Tidak Tersedia</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row" v-if="Object.values(listStockPagination).length > 0">
								<div class="col-12 col-md-12 mt-3">
									<div class="col-12 p-0">
										<div class="row">
											<div class="col-12 col-md-12">
												<div class="row">
													<div class="col-9 offset-1 col-md-12 ml-0 ml-md-0">
														<ul class="pagination float-md-left">
															<li v-if="listStockPagination.first_page==true" @click="paginationSerial(listStockPagination.current==1)">
																<a class="page-link background-mila rounded-left" href="#" aria-label="Previous">
																	<span aria-hidden="true"><img src="assets/icon/back_dobel.png"></span>
																</a>
															</li>
															<li v-if="listStockPagination.prev>=1" @click="paginationSerial(listStockPagination.prev)">
																<a class="page-link background-mila" href="#" aria-label="Previous">
																	<span aria-hidden="true"><img src="assets/icon/back.png"></span>
																</a>
															</li>
															<li @click="paginationSerial(page)" v-for="(page,index) in listStockPagination.detail" :key="index"><span class="page-link text-purple" :class="{active:page==listStockPagination.current}" >{{ page }}</span></li>
															<li v-if="listStockPagination.next!=0" @click="paginationSerial(listStockPagination.next)">
																<a class="page-link background-mila" href="#">
																	<span aria-hidden="true"><img src="assets/icon/back.png" style="transform: rotateY(180deg);"></span>
																</a>
															</li>
															<li v-if="listStockPagination.last_page==true" @click="paginationSerial(listStockPagination.total_page)">
																<a class="page-link background-mila rounded-right" href="#">
																	<span aria-hidden="true"><img src="assets/icon/back_dobel.png" style="transform: rotateY(180deg);"></span>
																</a>
															</li>
														</ul>
														<ul class="pagination float-md-right" :class="[listStockPagination.total_page==1 || listStockPagination.total_page==0 ? 'mt-md-4 mt-lg-0' : 'mt-md-n2 mt-lg-0']">
															<li @click="paginationSerial(listStockPagination.current)">
																<a class="page-link background-mila rounded text-white" href="#" aria-label="Previous">
																	<span aria-hidden="true" class="font-size-10"><img src="assets/icon/refresh.png" class="pr-1">Refresh</span>
																</a>
															</li>
															<li class="">
																<div class="btn-group">
																	<button type="button" class="btn btn-outline-purple dropdown-toggle background-white box-purple" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> {{currentLimit}}
																		<div class="dropdown-menu pagi-dropdown">
																			<span class="dropdown-item text-gray" v-for="(limit, index) in limit" :key="index" @click="getLimitSerial(limit)">{{limit}}</span>
																		</div>
																	</button>
																</div>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row" v-else-if="Object.values(riwayatStockPagination).length > 0">
								<div class="col-12 col-md-12 mt-3">
									<div class="col-12 p-0">
										<div class="row">
											<div class="col-12 col-md-12">
												<div class="row">
													<div class="col-9 offset-1 col-md-12 ml-0 ml-md-0">
														<ul class="pagination float-md-left">
															<li v-if="riwayatStockPagination.first_page==true" @click="paginationRiwayat(riwayatStockPagination.current==1)">
																<a class="page-link background-mila rounded-left" href="#" aria-label="Previous">
																	<span aria-hidden="true"><img src="assets/icon/back_dobel.png"></span>
																</a>
															</li>
															<li v-if="riwayatStockPagination.prev>=1" @click="paginationRiwayat(riwayatStockPagination.prev)">
																<a class="page-link background-mila" href="#" aria-label="Previous">
																	<span aria-hidden="true"><img src="assets/icon/back.png"></span>
																</a>
															</li>
															<li @click="paginationRiwayat(page)" v-for="(page,index) in riwayatStockPagination.detail" :key="index"><span class="page-link text-purple" :class="{active:page==riwayatStockPagination.current}" >{{ page }}</span></li>
															<li v-if="riwayatStockPagination.next!=0" @click="paginationRiwayat(riwayatStockPagination.next)">
																<a class="page-link background-mila" href="#">
																	<span aria-hidden="true"><img src="assets/icon/back.png" style="transform: rotateY(180deg);"></span>
																</a>
															</li>
															<li v-if="riwayatStockPagination.last_page==true" @click="paginationRiwayat(riwayatStockPagination.total_page)">
																<a class="page-link background-mila rounded-right" href="#">
																	<span aria-hidden="true"><img src="assets/icon/back_dobel.png" style="transform: rotateY(180deg);"></span>
																</a>
															</li>
														</ul>
														<ul class="pagination float-md-right" :class="[riwayatStockPagination.total_page==1 || riwayatStockPagination.total_page==0 ? 'mt-md-4 mt-lg-0' : 'mt-md-n2 mt-lg-0']">
															<li @click="paginationRiwayat(riwayatStockPagination.current)">
																<a class="page-link background-mila rounded text-white" href="#" aria-label="Previous">
																	<span aria-hidden="true" class="font-size-10"><img src="assets/icon/refresh.png" class="pr-1">Refresh</span>
																</a>
															</li>
															<li class="">
																<div class="btn-group">
																	<button type="button" class="btn btn-outline-purple dropdown-toggle background-white box-purple" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> {{filter.limit}}
																		<div class="dropdown-menu pagi-dropdown">
																			<span class="dropdown-item text-gray" v-for="(limit, index) in limit" :key="index" @click="getLimitRiwayat(limit)">{{limit}}</span>
																		</div>
																	</button>
																</div>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="modalDetailRiwayat" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" role="document">
				<DetailRiwayatStok :tanggal='tanggalDetail' :produk="selectedProduct"/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Datepicker from 'vuejs-datepicker';
import DetailRiwayatStok from '@/views/stock/DetailRiwayatStok'
import moment from 'moment';
import carousel from 'vue-owl-carousel';

export default {
	name:'Stock',
	components : {
		DetailRiwayatStok,
		Datepicker,
		carousel,
	},
	data() {
		return {
			produk: '',
			tanggalDetail:'',
			selectedProduct: {
				name: '',
				image: '',
			},
			pilihanSerial:'3',
			hal:'',
			tab: 'riwayat',
			status:'',
			currentLimit:12,
			currentDate :'',
			limit:[5, 10, 20, 50, 100, 200],
			pilihanStatusSerial:[{value:'0' , name: 'Tersedia'}, {value:'1' , name:'Kadaluarsa'}, {value:'2', name:'Terjual'}, {value:'3' , name: 'Semua'}],
			tanggalAwal:'',
			tanggalAkhir:'',
			tanggalAwalPembelian:'',
			tanggalAkhirPembelian:'',
			tanggalAwalTerjual:'',
			tanggalAkhirTerjual:'',
			tanggalAwalKadaluarsa:'',
			tanggalAkhirKadaluarsa:'',
			tanggalPembelian:{
				value:'',
				comparison:'bet',
				type:'date',
				field:'stock_serial_buy_datetime',
			},
			tanggalKadaluarsa:{
				value:'',
				comparison:'bet',
				type:'date',
				field:'stock_serial_expired_datetime',
			},
			tanggalTerjual:{
				value:'',
				comparison:'bet',
				type:'date',
				field:'stock_serial_sell_datetime',
			},
			noSerial: {
				value:'',
				comparison:'=',
				type:'string',
				field:'stock_serial_value'
			},
			tipe: {
				value:'',
				comparison:'=',
				type:'string',
				field:'stock_serial_type'
			},
			stock_serial_used_for: {
				value:'store',
				comparison:'=',
				type:'string',
				field:'stock_serial_used_for'
			},
			statusSerialExpired: {
				value: '',
				comparison:'',
				type:'date',
				field: 'stock_serial_expired_datetime',
			},
			statusSerial: {
				value: '',
				comparison:'=',
				type:'string',
				field: 'stock_serial_status',
			},
			params:[],
			page: 1,
		}
	},

	computed: {
		...mapState('stockList', ['stock', 'filter', 'riwayatStockPagination','riwayatStockResults', 'listStockPagination', 'listStockResults', 'detailRiwayat', 'summarySerial']),
		...mapGetters('auth', ['isAuth']),
	},

	methods: {
		...mapActions('stockList', ['getStock', 'getRiwayatStock', 'getListSerial', 'getDetailStock', 'getSummarySerial']),

		cekExpiredDates(status, date){
			if (status == 1) {
				return `<span class="pt-1 pb-2 pl-2 background-purple float-right text-white font-size-9 rounded-bot-left-pill stok-badge text-center"> TERJUAL </span>`
			} else if(moment(date).isBefore(this.currentDate)) {
				return `<span class="pt-1 pb-2 pl-2 background-gray-dark float-right text-white font-size-9 rounded-bot-left-pill stok-badge text-center"> KADALUARSA </span>`
			} else {
				return 	`<span class="pt-1 pb-2 pl-2 background-green float-right text-white font-size-9 rounded-bot-left-pill stok-badge text-center"> TERSEDIA</span>`
			}
		},

		getDate () {
			let datetime = moment().format('YYYY-MM-DD hh:mm:ss');
			this.currentDate = datetime;
		},

		riwayatSerial() {
			this.tab = "riwayat"
			this.filter.limit = 10
			this.params = []
			this.tanggalAwal = ''
			this.tanggalAkhir = ''
			this.getRiwayatStock(this.filter)
		},

		paginationRiwayat(val) {
			this.filter.page = val
			this.getRiwayatStock(this.filter)
		},

		getLimitRiwayat(limit) {
			this.filter.limit = limit
			this.getRiwayatStock(this.filter)
		},

		cariRiwayat(){
			if(!this.tanggalAkhir) {
				this.tanggalAkhir = Date.now()
			} else if(!this.tanggalAwal) {
				this.tanggalAwal = this.tanggalAkhir
			}
			if(this.tanggalAwal && this.tanggalAkhir) {
				this.filter.filter[0].value = moment(this.tanggalAwal).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhir).format('YYYY-MM-DD')
			}
			this.getRiwayatStock(this.filter)
		},

		resetRiwayat() {
			this.tanggalAwal = ''
			this.tanggalAkhir = ''
			this.filter.filter[1].value = ''
			this.filter.limit = 10
			this.getRiwayatStock()
		},

		getDataSerial() {
			this.params.push(this.stock_serial_used_for)
			this.getListSerial({status:this.status, limit:this.currentLimit, hal: this.page, paramFilter:this.params})
		},

		tipeSerial(val, name) {
			this.tab = "serial"
			this.resetFilterSerial()
			this.params = []
			this.tipe.value = val
			this.params.push(this.tipe)
			this.currentLimit = 12
			this.status = val
			this.produk = name
			this.getDataSerial()
		},

		getLimitSerial(limit) {
			this.currentLimit = limit
			this.page = 1
			this.getDataSerial()
		},

		paginationSerial(val) {
			this.page = value
			this.getDataSerial()
		},

		cariSerial () {
			this.params = []
			if(this.tanggalAwalPembelian && this.tanggalAkhirPembelian) {
				this.tanggalPembelian.value = moment(this.tanggalAwalPembelian).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhirPembelian).format('YYYY-MM-DD')
				this.params.push(this.tanggalPembelian)
			}
			if(this.tanggalAwalTerjual && this.tanggalAkhirTerjual) {
				this.tanggalTerjual.value = moment(this.tanggalAwalTerjual).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhirTerjual).format('YYYY-MM-DD')
				this.params.push(this.tanggalTerjual)
			}
			if(this.tanggalAwalKadaluarsa && this.tanggalAkhirKadaluarsa) {
				this.tanggalKadaluarsa.value = moment(this.tanggalAwalKadaluarsa).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhirKadaluarsa)
				this.params.push(this.tanggalKadaluarsa)
			}
			if(this.noSerial.value) {
				this.params.push(this.noSerial)
			}
			if(this.status) {
				this.tipe.value = this.status
				this.params.push(this.tipe)
			}
			if(this.pilihanSerial) {

				if(this.pilihanSerial == 0) {
					this.statusSerial.value = '0'
					this.statusSerialExpired.comparison = '>'
					this.statusSerialExpired.value = moment(this.currentDate).format('YYYY-MM-DD')
					this.params.push(this.statusSerial)
					this.params.push(this.statusSerialExpired)
				} else if(this.pilihanSerial == 1) {
					this.statusSerial.value = '0'
					this.statusSerialExpired.comparison = '<'
					this.statusSerialExpired.value = moment(this.currentDate).format('YYYY-MM-DD')
					this.params.push(this.statusSerial)
					this.params.push(this.statusSerialExpired)
				} else if(this.pilihanSerial == 2) {
					this.statusSerial.value = '1'
					this.params.push(this.statusSerial)
				} else {
					this.statusSerial.value = ''
				}
			}
			this.currentLimit = 12
			this.page = 1
			this.getDataSerial()
		},
		async resetSerial() {
			await this.resetFilterSerial()
			this.params = []
			await this.getDataSerial()
		},
		resetFilterSerial() {
			this.tanggalAwalPembelian = ''
			this.tanggalAkhirPembelian = ''
			this.tanggalAwalTerjual = ''
			this.tanggalAkhirTerjual = ''
			this.tanggalAwalKadaluarsa = ''
			this.tanggalAkhirKadaluarsa = ''
			this.noSerial.value = ''
			this.statusSerial.value = ''
			this.pilihanSerial = 3
			this.tanggalPembelian.value = ''
		},

		getDetail(val) {
			this.tanggalDetail = val.stock_log_daily_date
			this.selectedProduct = {
				name: val.product_name,
				image: val.product_image_filename,
			}
			this.getDetailStock({date: val.stock_log_daily_date, product_code: val.product_code})
		},
	},

	created() {
		this.getStock();
		this.getRiwayatStock(this.filter);
		this.getDate();
		this.getSummarySerial()
		this.$store.dispatch('setPageTitle', `Stok Produk`);
	},
// beforeDestroy() {
// 	this.reset();
// }
};
</script>
<style>
.btn-cari-serial, .btn-reset-serial {
	width: 8.7em;
}
.page-link.active {
	z-index: 2;
	color: #0056b3;
	text-decoration: none;
	background-color: #e9ecef;
	border-color: #dee2e6;
}
.vdp-datepicker input {
	background-color: #ffffff!important;
}
.vdp-datepicker {
	width: 100%;
	margin-right: 8px;	
}
.pl-pr {
	padding-left: 10px !important;
	padding-right: 20px !important;
}
.pagi-dropdown {
	min-width: 5rem !important;
}
@media (max-width: 425px){
	.vdp-datepicker {
		padding-bottom:8px;
	}
}
@media (min-width: 414px) and (max-width: 415px) {
	.btn-cari {
		margin-right: -7px !important;
		width: 11.2em;
	}
}
@media (min-width: 320px) and (max-width: 450px) {
	.vdp-datepicker__calendar:nth-child(2), .vdp-datepicker__calendar:nth-child(3), .vdp-datepicker__calendar:nth-child(4){
		width: 243px !important;
		margin-left: -122px;
	}
}
@media (min-width: 414px) and (max-width: 600px) {
	.pl-pr2 {
		padding-left: 30px !important;
		padding-right: 30px !important;
	}
	.pl-pr {
		padding-left: 15px !important;
		padding-right: 25px !important;
	}
}
@media (min-width: 375px) and (max-width: 413px) {
	.pl-pr {
		padding-left: 10px !important;
		padding-right: 20px !important;
	}
	.btn-cari {
		width: 10em;
	}
}
@media (min-width: 360px) and (max-width: 374px) {
	.btn-cari {
		width: 9.5em;
	}
}
@media (min-width: 320px) and (max-width: 374px) {
	.pl-pr {
		padding-left: 0px !important;
		padding-right: 15px !important;
	}
}
@media (min-width: 120px) and (max-width: 320px) {
	.btn-cari {
		width: 8.3em;
	}
}
</style>